import { Table } from "antd";

const CommonTable = ({
  columns,
  dataSource,
  loading = false,
  pagination = { pageSize: 10 },
  rowKey = "id",
  ...rest
}) => {
  const enhancedColumns = columns?.map((col) => ({
    ...col,
    onCell: (record, rowIndex) => ({
      className: "word-break-keep-all",
    }),
  }));

  return (
    <div className="border rounded custom-table-container">
      <Table
        columns={enhancedColumns}
        dataSource={dataSource}
        loading={loading}
        rowKey={rowKey}
        scroll={{ x: "max-content" }}
        pagination={
          pagination?.total > pagination?.pageSize
            ? {
                responsive: true,
                position: ["bottomCenter"],
                ...pagination,
              }
            : false
        }
        {...rest}
      />
    </div>
  );
};

export default CommonTable;
